// extracted by mini-css-extract-plugin
export default {"icon":"Search_icon__6AO1n","pointer":"Search_pointer__7aaYm"};